module.exports = __webpack_public_path__ + "img/WSM.5e53f150.svg";